/**
 * Set the safe area inset top value, ensuring compatibility with devices that have 
 * notches, such as iPhones with Face ID, so that the content is not obstructed by the notch.
 * 
 */
export default function setSafeAreaInsetTop(top = '44px') {
  return `max(env(safe-area-inset-top, ${top}), ${top})`
}